import { render, staticRenderFns } from "./OnRatiosTableHeaders1.vue?vue&type=template&id=25ee4992&"
import script from "./OnRatiosTableHeaders1.vue?vue&type=script&lang=js&"
export * from "./OnRatiosTableHeaders1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports